import textOverflow from '@/components/text/overflow'

function renderText(h) {
  return h(
    textOverflow,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'copyright'
    },
    [ renderText.call(this, h) ]
  )
}
